/**
 * XVI common form widget component
 */
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AbstractControl } from '@angular/forms';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-form-widget',
  styleUrls: ['form-widget.component.scss'],
  templateUrl: 'form-widget.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class XVIFormWidgetComponent {
  @Input() public field: any;
  @Input() public control: AbstractControl;
}
